import React from 'react';
import { Button } from 'primereact/button';

const Invoice = (props) => {
    const print = () => {
        window.print();
    };

    return (
        <div>
            <Button type="button" label="Print" icon="pi pi-print" onClick={print} style={{ display: 'block', marginBottom: '20px', marginLeft: '6px' }}></Button>

            <div className="grid">
                <div className="col">
                    <div className="card">
                        <div id="invoice-content">
                            <div className="invoice">
                                <div className="invoice-header">
                                    <div className="invoice-company">
                                        {/* <img id="invoice-logo" className="logo-image" src={props.logoUrl} alt="diamond-layout" /> */}
                                        <div className="company-name">Software Type</div>
                                        <div>Online car reservation</div>
                                    </div>
                                    <div>
                                        <div className="invoice-title">INVOICE</div>
                                        <div className="invoice-details">
                                            <div className="invoice-label">Client: </div>
                                            <div className="invoice-value" style={{padding: 0, margin: 0, fontSize: '12px'}}>Jubaid Hassan (USA)</div>
                                            <div className="invoice-label">Date</div>
                                            <div className="invoice-value" style={{padding: 0, margin: 0, fontSize: '12px'}}>10/04/2023</div>
                                            <div className="invoice-label">Duration:</div>
                                            <div className="invoice-value" style={{padding: 0, margin: 0, fontSize: '12px'}}>4 months</div>

                                            {/* <div className="invoice-label">INVOICE #</div>
                                            <div className="invoice-value">8523</div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-items">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{textAlign: 'left'}}>Service</th>
                                                <th style={{textAlign: 'left'}}>Features</th>
                                                <th style={{textAlign: 'left'}}>Revession</th>
                                                <th style={{textAlign: 'left'}}>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1. Software Development</td>
                                                <td style={{padding:'0'}}>
                                                    <ul style={{listStyleType:'none', textAlign: 'left'}}>
                                                        <li>i) Back-end</li>
                                                        <li>ii) Front-end</li>
                                                        <li>iii) Admin Pannel</li>
                                                        <li>iv) Live Chat (WhatsApp + Tawk)</li>
                                                        <li>v) Send invoice to client by email</li>
                                                        <li>vi) Get reservation notification on phone by sms</li>
                                                        <li>vii) Auto trip cancel option</li>
                                                        <li>viii) Own review taking option</li>
                                                        <li>xi) Google map review add</li>
                                                        <li>x) Tripadvisor review add</li>
                                                        <li>xi) Social media account create and add</li>
                                                        <li>xii) SEO supportable design</li>

                                                    </ul>
                                                </td>
                                                <td  style={{textAlign: 'left'}}>After complete 3 months free support</td>
                                                <td  style={{textAlign: 'left'}}>$2800.00</td>
                                            </tr>
                                            <tr>
                                                <td>2. Server set-up</td>
                                                <td style={{padding:'0'}}>
                                                    <ul style={{listStyleType:'none' , textAlign: 'left'}}>
                                                        <li>i) Live Software</li>
                                                        <li>ii) Domain setup</li>
                                                        <li>iii) 2 Business Email configuration</li>
                                                    </ul>
                                                </td>
                                                <td  style={{textAlign: 'left'}}>After complete 3 months free support</td>
                                                <td  style={{textAlign: 'left'}}>$430.00</td>
                                            </tr>
                                            <tr>
                                                <td>3. Graphic design</td>
                                                <td style={{padding:'0'}}>
                                                    <ul style={{listStyleType:'none' , textAlign: 'left'}}>
                                                        <li>i) Brand logo design (1)</li>
                                                        <li>ii) Banner (1)</li>
                                                        <li>iii) Homepage car (5)</li>
                                                        <li>iv) 4 simple step logo (4)</li>
                                                        <li>v) Search by brand logo (5)</li>
                                                        <li>vi) Social media logo design (5)</li>
                                                        <li>vii) All car design (for step 2 choose a car section) (6)</li>
                                                    </ul>
                                                </td>
                                                <td  style={{textAlign: 'left'}}>3 times</td>
                                                <td  style={{textAlign: 'left'}}>$350.00</td>
                                            </tr>
                                            <tr>
                                                <td>4. Future service (Not included)</td>
                                                <td style={{padding:'0'}}>
                                                    <ul style={{listStyleType:'none' , textAlign: 'left'}}>
                                                        <li>i) Social media marketing</li>
                                                        <li>ii) SEO (search engine optimization)</li>
                                                    </ul>
                                                </td>
                                                <td  style={{textAlign: 'left'}}>Not applicable for this invoice</td>
                                                <td  style={{textAlign: 'left'}}>None</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="invoice-summary">
                                    <div className="invoice-notes">
                                        <b>Terms of service</b>
                                        <div>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                i)  <span>First 40% advance payment on starting.</span>
                                            </p>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                ii)  <span>Second 30% payment before server set-up(2)</span>
                                            </p>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                iii)  <span>Third 30% payment after server set-up (after everythink functional)</span>
                                            </p>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                iii)  <span>This price quotation is only for one(first) website</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="invoice-details">
                                            <div  style={{textAlign: 'left'}} className="invoice-label">SUBTOTAL</div>
                                            <div className="invoice-value">$3580.00</div>

                                            <div className="invoice-label">VAT</div>
                                            <div className="invoice-value">0</div>

                                            <div className="invoice-label">TOTAL</div>
                                            <div className="invoice-value">$3580.00</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.logoUrl === nextProps.logoUrl;
};

export default React.memo(Invoice, comparisonFn);
